/* eslint no-console: 0 */

import { ErrorHandler, Injectable } from '@angular/core';
import { EnvService } from '../configuration/env.service';
import { GeneralMessageService } from './../shared/general-message/general-message.service';

@Injectable()
export class CustomErrorHandler implements ErrorHandler {
    LOG_SOURCE = 'CenterlineSelectionComponent';
    constructor(private readonly env: EnvService, private readonly generalMessageService: GeneralMessageService) {}

    handleError(error) {
        this.generalMessageService.showDialog({ title: 'Error', message: 'Internal Server Error' });
        if (this.env.config.errorLog.logErorrsToConsole) {
            console.error(error);
        }
    }
}
